import { useEffect } from "react";
import {
  ALEXANDER_ALI_PERSON_ID,
  BELLHOPT_HOMEPAGE_WEBPAGE_ID,
  BELLHOPT_ORGANIZATION_ID,
  organizationRef,
  personRef,
} from "./siteEntityRefs";

export const siteStructuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": BELLHOPT_ORGANIZATION_ID,
      name: "Bellhopt",
      url: "https://www.bellhopt.com",
      logo: "https://www.bellhopt.com/logo.png",
      founder: [
        {
          "@id": "https://www.bellhopt.com/#alexander-ali",
        },
        {
          "@id": "https://www.bellhopt.com/#milad-ghods",
        },
      ],
    },
    {
      "@type": "Person",
      "@id": ALEXANDER_ALI_PERSON_ID,
      name: "Alexander Ali",
      url: "https://www.bellhopt.com",
      sameAs: ["https://www.linkedin.com/in/alexander-ali-bellhopt/"],
      jobTitle: "Founder",
      description:
        "Co-founder of Bellhopt, a short-term rental concierge platform. Alexander focuses on software integrations, API and backend development, operations systems, product strategy, product roadmap, and technology that supports pre-arrival grocery delivery, guest experience, and ancillary revenue for hospitality operators.",
      worksFor: {
        "@id": "https://www.bellhopt.com/#organization",
      },
      affiliation: {
        "@id": "https://www.bellhopt.com/#organization",
      },
      worksFor: organizationRef(),
      affiliation: organizationRef(),
      knowsAbout: [
        "Software Engineering",
        "Software Development",
        "Software Integrations",
        "API Development",
        "Backend Development",
        "Data Engineering",
        "Data Integration",
        "PMS Integrations",
        "Operations",
        "Operations Systems",
        "Product Strategy",
        "Product Roadmap",
        "Product Development",
        "Product Engineering",
        "Hospitality Technology",
        "Vacation Rental Technology",
        "Short-Term Rental Technology",
        "Concierge Software",
        "Guest Experience",
        "Pre-Arrival Grocery Delivery",
        "Ancillary Revenue",
        "Strategic Partnerships",
        "Hospitality Partnerships",
        "Vacation Rental Partnerships",
      ],
    },
    {
      "@type": "Person",
      "@id": "https://www.bellhopt.com/#milad-ghods",
      name: "Milad Ghods",
      url: "https://www.bellhopt.com",
      sameAs: ["https://www.linkedin.com/in/miladghods/"],
      jobTitle: "Founder",
      description:
        "Co-founder of Bellhopt, a hospitality technology company providing pre-arrival grocery delivery and in-home stocking for short-term rentals. Milad focuses on sales, business development, operations, property manager relationships, hospitality partnerships, and the operational logistics that help operators offer hotel-style guest experiences.",
      worksFor: {
        "@id": "https://www.bellhopt.com/#organization",
      },
      affiliation: {
        "@id": "https://www.bellhopt.com/#organization",
      },
      knowsAbout: [
        "Sales",
        "Business Development",
        "Go-to-Market Strategy",
        "Customer Relationships",
        "Post-Sales Operations",
        "Operations",
        "Hospitality Operations",
        "Short-Term Rental Operations",
        "Property Management",
        "Property Manager Partnerships",
        "Hospitality Partnerships",
        "Vacation Rental Partnerships",
        "Pre-Arrival Grocery Delivery",
        "In-Home Stocking",
        "Short-Term Rental Technology",
        "Hospitality Technology",
        "Concierge Software",
        "Guest Experience",
      ],
    },
  ],
};

export function useSiteStructuredData(active = true) {
  useEffect(() => {
    if (!active) {
      return undefined;
    }

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.siteStructuredData = "true";
    script.text = JSON.stringify(siteStructuredData);
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [active]);
}

export default function SiteStructuredData() {
  useSiteStructuredData(true);
  return null;
}
